export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-unlock-a876a20567934dbd711a38a8830d96c7.svg";